import React from 'react';
import { ThreeDots } from 'react-loader-spinner';

export default function ThreeDotsLoader({color}) {
    return <ThreeDots wrapperStyle={{ display: '' }} color={color?color:'#fff'} height={16} width={40} />;
}
